import * as React from 'react';
import * as Sentry from '@sentry/react';
import { radius, colors, fonts, fontSizes } from '../style';

interface State {
	hasError: boolean;
	error: Error | null;
}

/** Catches unhandled React rendering errors and shows a fallback UI */
export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
	state: State = { hasError: false, error: null };

	static getDerivedStateFromError(error: Error): State {
		return { hasError: true, error };
	}

	componentDidCatch(error: Error, info: React.ErrorInfo) {
		console.error('ErrorBoundary caught an error:', error, info.componentStack);
		Sentry.captureException(error, { extra: { componentStack: info.componentStack } });
	}

	private handleReload = () => {
		window.location.reload();
	};

	render() {
		if (this.state.hasError) {
			return (
				<div style={{ padding: 40, textAlign: 'center', fontFamily: fonts.normal }}>
					<h2>Något gick fel</h2>
					<p style={{ color: colors.icon }}>Ett oväntat fel har inträffat. Försök att ladda om sidan.</p>
					<button
						onClick={this.handleReload}
						style={{
							marginTop: 16,
							padding: '10px 24px',
							fontSize: fontSizes.md,
							cursor: 'pointer',
							border: `1px solid ${colors.faded}`,
							borderRadius: radius.normal,
							background: colors.white,
						}}
					>
						Ladda om
					</button>
				</div>
			);
		}
		return this.props.children;
	}
}
